<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <!-- <template v-slot:activator="{ on }">
          <v-btn color="primary" dark @click="newFatwora">عمل فاتورة وتحويلها لقيد التنفيذ</v-btn>
        </template> -->
        <v-card>
          <v-toolbar dark color="orange">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>اغلاق</v-toolbar-title>
            <v-toolbar-title>تعديل امر التوريد</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            أمر التوريد
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="dialog = false">حفظ</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-card>
              <div id="printMe">
                <div style="direction:rtl">
                  <v-card-text>
                    <v-form ref="form">
                      <v-container grid-list-md>
                        <!--  order detail -->
                        <div
                          v-if="
                            order_detail_to_fatwora.id &&
                              order_detail_to_fatwora.id != ''
                          "
                        >
                          <p class="head_p">تفاصيل أمر التوريد</p>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md1>
                              كود : {{ order_detail_to_fatwora.code }}
                            </v-flex>
                            <v-flex xs12 sm6 md1>
                              <!-- السعر الكلي : {{ order_detail_to_fatwora.price }} -->
                              السعر الكلي : {{ total_price_compute }}
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                              نوع السداد :
                              {{ order_detail_to_fatwora.sdad_type_name }}
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                              حالة السداد :
                              {{ order_detail_to_fatwora.sdad_status }}
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                              اسم العميل :
                              {{ order_detail_to_fatwora.client_name }}
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                              تاريخ التسليم :
                              {{ order_detail_to_fatwora.taslim_date }}
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                              التاريخ : {{ order_detail_to_fatwora.created_at }}
                            </v-flex>

                            <v-flex xs12 sm6 md12>
                              <v-data-table
                                :headers="headers3"
                                :items="order_detail_to_fatwora.order_items"
                                class="elevation-1"
                                :rows-per-page-items="rowsPerPageItems"
                              >
                                <template slot="items" slot-scope="props">
                                  <td>{{ props.item.item_name }}</td>
                                  <td>
                                    <v-text-field
                                      type="number"
                                      v-model="props.item.item_num"
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-text-field
                                      type="number"
                                      v-model="props.item.price"
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    {{
                                      (props.item.total_price = item_total_price_compute(
                                        props.item
                                      ))
                                    }}
                                  </td>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close"
                      >الغاء</v-btn
                    >
                    <v-btn color="blue darken-1" flat @click="save('form2')"
                      >حفظ</v-btn
                    >
                  </v-card-actions>
                  <v-layout> </v-layout>
                </div>
              </div>
            </v-card>
          </v-list>
        </v-card>
      </v-dialog>

      <v-data-table
        :headers="headers2"
        :items="orders"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.client_name }}</td>
          <td class="text-xs-right">{{ props.item.price }}</td>
          <td class="text-xs-right">{{ props.item.emp_create_order }}</td>
          <td class="text-xs-right">{{ props.item.taslim_date }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
          <td>
            <v-icon small class="ml-4" @click="detailItem(props.item)">
              book
            </v-icon>
          </td>
          <td style="padding:0px">
            <v-btn
              small
              color="success"
              class="custom-btn"
              @click="editOrder(props.item)"
              >تعديل</v-btn
            >

            <v-btn
              small
              color="primary"
              class="custom-btn"
              @click="confirm_order(props.item)"
              >تأكيد</v-btn
            >
            <v-btn
              style="margin:4px 0"
              small
              color="error"
              class="custom-btn"
              @click="reject_order(props.item)"
              >مسح</v-btn
            >
          </td>
          <!-- <td >
            <v-btn
            small
            :disabled="props.item.status != '0'"
            @click="search_client(props.item);is_edit=true;"
            >
            <v-icon>edit</v-icon>
            </v-btn>
          </td> -->
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <!-- dialog view order detail -->
    <v-dialog v-model="detail_dialog" width="800" dark style="padding:10px">
      <v-card>
        <v-card-title class="headline orange lighten-2" primary-title>
          تفاصيل امر التوريد
        </v-card-title>

        <v-card-text>
          <v-layout row>
            <v-flex xs12 sm6 md2>
              الكود
              <br />
              {{ order_detail.code }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              السعر
              <br />
              {{ order_detail.price }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              المندوب
              <br />
              {{ order_detail.emp_create_order }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              اسم العميل
              <br />
              {{ order_detail.client_name }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              تاريخ التسليم
              <br />
              {{ order_detail.taslim_date }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              التاريخ
              <br />
              {{ order_detail.created_at }}
            </v-flex>
          </v-layout>
          <hr />
          <v-data-table
            :headers="headers3"
            :items="order_detail.order_items"
            class="elevation-1"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.item_name }}</td>
              <td>{{ props.item.item_num }}</td>
              <td>{{ props.item.price }}</td>
              <td>{{ props.item.total_price }}</td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="detail_dialog = false">
            موافق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  reject_order,
  orders_and_fatwora_page,
  confirm_order_from_super,
  update_order_from_super,
  delete_order_from_super
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,
    detail_dialog: false,
    order_detail: {},
    order_detail_to_fatwora: {},
    select_mandob_tawzi3: {},
    mandobs_tawzi3: [],

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    select_sadad_type: { id: "" },
    select_client: { id: "" },
    select_employer: { id: "" },
    select_store: { id: "" },
    select_item: { id: "" },
    select_sadadstatuses: { id: "" },

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },

    headers2: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "اسم العميل", value: "client_name", align: "right" },
      { text: " السعر", value: "price", align: "right" },
      { text: "  المندوب", value: "emp_create_order", align: "right" },
      { text: "  تاريخ التسليم", value: "taslim_date", align: "right" },
      { text: "  التاريخ ", value: "taslim_date", align: "right" },
      { text: "  التفاصيل", value: "", sortable: false, align: "right" },
      { text: "  التحكم", value: "", sortable: false, align: "right" }
      // { text: "فاتورة جديدة", value: "", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      { text: " السعر", value: "price", sortable: false, align: "right" },
      {
        text: "  السعر الكلي",
        value: "emp_create_order",
        sortable: false,
        align: "right"
      }
    ],
    orders: [],
    order: {},
    fatworas: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    m_items: [],
    stores: [],
    client_search_name: "",
    sadadstatuses: [],
    madionia_sabqa_of_madionia: "",
    newItem: {
      id: "",
      code: "",
      madionia_sabqa: "",
      madionia_now: "",
      discount: "",
      price_before: "",
      price_after: "",
      remain: "",
      sdad_type_name: "",
      sdad_status: "",
      emp_create_fatwora: "",
      emp_sales_response_name: "",
      client_name: "",
      taslim_date: "",
      store_id: "",
      sadad_type_id: "",
      sdad_status_id: "",
      client_id: "",
      emp_sales_response_id: "",
      created_at: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      client_id: "",
      emp_id: ""
    },
    added_items: [],
    item_num_before: "",
    item_num: "",
    item_num_after: "",
    item_discount: "",
    item_bonus: "",
    price: "",
    total_price: "",
    final_price: "",
    is_edit: false,
    items_of_old_fatwora: []
  }),

  computed: {
    item_total_price_compute() {
      return function(item) {
        //  const index = this.order_detail_to_fatwora.order_items.indexOf(item);
        //   return  this.order_detail_to_fatwora.order_items[index].total_price = parseFloat(this.order_detail_to_fatwora.order_items[index].price) * parseFloat(this.order_detail_to_fatwora.order_items[index].item_num)
        return (item.total_price =
          parseFloat(item.price) * parseFloat(item.item_num));
      };
    },
    total_price_compute() {
      let total = 0;
      for (
        let k = 0;
        k < this.order_detail_to_fatwora.order_items.length;
        k++
      ) {
        total += this.order_detail_to_fatwora.order_items[k].total_price;
      }
      //   return  this.order_detail_to_fatwora.order_items[index].total_price = parseFloat(this.order_detail_to_fatwora.order_items[index].price) * parseFloat(this.order_detail_to_fatwora.order_items[index].item_num)
      return total;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    mycode() {
      if (this.fatworas.length > 0) {
        return (this.code =
          parseInt(this.fatworas[this.fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    gettotalpriceitem() {
      if (this.item_num != "" && this.price != "") {
        this.total_price = parseInt(this.item_num) * parseFloat(this.price);
        return this.total_price;
      } else {
        return (this.total_price = 0);
      }
    },
    get_item_num_after() {
      if (this.item_bonus != 0 && this.item_bonus != null && this.item_bonus) {
        this.item_num_after =
          parseInt(this.item_num) + parseFloat(this.item_bonus);
        return this.item_num_after;
      } else if (this.item_num != "") {
        return (this.item_num_after = parseInt(this.item_num));
      } else {
        return (this.item_num_after = 0);
      }
    },
    get_item_final_price() {
      if (
        this.item_discount != "" &&
        this.item_discount != null &&
        this.item_discount
      ) {
        this.final_price =
          parseFloat(this.total_price) - parseFloat(this.item_discount);
        return this.final_price;
      } else if (this.total_price != "") {
        return (this.final_price = this.total_price);
      } else {
        return (this.final_price = 0);
      }
      return (this.final_price = parseFloat(this.total_price));
    },

    fatwora_price() {
      let tot_price = 0;
      for (let index = 0; index < this.added_items.length; index++) {
        tot_price += parseFloat(this.added_items[index].final_price);
      }
      return (this.newItem.price_before = tot_price);
    },
    fatwora_final_price() {
      if (this.newItem.price_before != "" && this.newItem.discount != "") {
        return (this.newItem.price_after =
          parseFloat(this.newItem.price_before) -
          parseFloat(this.newItem.discount));
      }
      return (this.newItem.price_after = this.newItem.price_before);
    },
    madionia_now() {
      if (this.newItem.price_after > 0) {
        return (this.newItem.madionia_now =
          parseFloat(this.newItem.madionia_sabqa) +
          parseFloat(this.newItem.price_after));
      }
      return (this.newItem.madionia_now = this.newItem.madionia_sabqa);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    // this.initialize()

    this.order_page();
  },

  methods: {
    order_page() {
      orders_and_fatwora_page().then(response => {
        this.mandobs_tawzi3 = response.data.mandobs_tawzi3;
        this.m_sadad_types = response.data.sadadtypes;
        this.m_employers = response.data.employers;
        this.clients = response.data.clients;
        this.fatworas = response.data.fatworas;
        this.stores = response.data.stores;
        this.sadadstatuses = response.data.sadadstatuses;
        this.orders = response.data.orders_confirmation;

        this.pagination.totalItems = response.data.orders_confirmation.length;
        this.loading = false;
      });
    },

    item_total_price(item) {
      const index = this.order_detail_to_fatwora.order_items.indexOf(item);
      return (this.order_detail_to_fatwora.order_items[index].total_price =
        parseFloat(this.order_detail_to_fatwora.order_items[index].price) *
        parseFloat(this.order_detail_to_fatwora.order_items[index].item_num));
    },
    initialize() {},
    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.orders.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_order_from_super(frmData2, item.id).then(response => {
            this.loading = false;
            this.orders.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      var frmData = new FormData();
      frmData.append("id", this.order_detail_to_fatwora.id);
      frmData.append("total", this.total_price_compute);
      frmData.append(
        "order_items",
        JSON.stringify(this.order_detail_to_fatwora.order_items)
      );
      update_order_from_super(frmData).then(response => {
        this.$router.go(0);
      });
    },

    detailItem(order) {
      this.order_detail = order;
      this.detail_dialog = true;
    },
    editOrder(order) {
      this.order_detail_to_fatwora = order;
      this.dialog = true;
    },
    confirm_order(order) {
      var frmData = new FormData();
      frmData.append("id", order.id);
      confirm_order_from_super(frmData).then(response => {
        this.order_page();
      });
    },
    reject_order(order) {
      reject_order(order.id).then(response => {
        Vue.set(
          this.orders,
          this.orders.findIndex(f => f.id === order.id),
          response.data
        );
      });
    },

    newFatwora() {
      this.order_detail_to_fatwora = {};
      let myUser = JSON.parse(localStorage.getItem("user"));
      this.dialog = true;
      this.added_items = [];
      this.select_client = { id: "" };
      this.newItem.taslim_date = "";
      this.newItem.created_at = "";
      this.newItem.madionia_sabqa = "";
      this.newItem.madionia_now = "";
      this.newItem.price = "";
      this.newItem.final_price = "";
      this.newItem.emp_sales_response_name = myUser.name;
      // this.newItem.emp_sales_response_id = myUser.id;
      this.is_edit = false;
    },

    printDiv(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;

      document.body.classList.add("rtl");
      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
      return true;
    }
  }
};
</script>

<style scoped>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
.custom-btn {
  padding: 0px;
  margin: 0px;
  width: 5px !important;
}
.v-input__control {
  height: 62px;
}
/* 
@media print {
  body * {
    visibility: hidden;
  }
  .printMe,
  .printMe * {
    visibility: visible;
  }
  .printMe {
     width: 100%; 
    position: absolute;
    left: 0;
    top: 0;
  }
}
    */
.rtl {
  direction: rtl !important;
  text-align: right !important;
}
.head_p {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  text-decoration: underline;
}
</style>
